export default "__VITE_ASSET__C9U$6pQQ__"